
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
function AboutPage() {
    const { t } = useTranslation('common');
    return (<div className="bg-white p-4 m-4 sm:rounded">
            <h1 className="text-xl">{t('about')} cphsecuritywait.dk</h1>
            <p className="my-4" dangerouslySetInnerHTML={{ __html: t('about-text') }}/>
        </div>);
}
export default AboutPage;

    async function __Next_Translate__getStaticProps__1a1723ec600__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec600__ as getStaticProps }
  